import { c as _c } from "react/compiler-runtime";
import { StatusScreen } from "@/components/ui/status-screen";
import { cx } from "@/lib/tailwind-utils";

/** A confirmed missing clinic, not an invalid verification code. */
export function ClinicLinkError(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("min-h-dvh", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div role="alert"><StatusScreen className={t1} title="This clinic link isn't valid" message="Please contact your clinic and ask for a new patient portal link." /></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}